<!-- 项目信息 -->
<template>
  <div>
    <k-form-build
      :value="jsonData"
      ref="KFB"
    />
  </div>
</template>
<script>
export default {
  name: 'ProjectSponsor',
  data() {
    return {
      jsonData: {
        'list': [
          {
            'type': 'input',
            'icon': 'icon-edit',
            'options': {
              'width': '100%',
              'minRows': 4,
              'maxRows': 6,
              'maxLength': null,
              'defaultValue': '',
              'clearable': false,
              'hidden': false,

              'placeholder': '中心编号'
            },
            'model': '80f29630-fbb3-092e-a8c2-938f49bb21c2',
            'key': '80f29630-fbb3-092e-a8c2-938f49bb21c2',
            'rules': [
              {
                'required': false,
                'message': '必填项'
              }
            ]
          }
        ],
        'config': {
          'layout': 'vertical',
          'labelCol': {
            'span': 4
          },
          'wrapperCol': {
            'span': 18
          },
          'hideRequiredMark': false,
          'customStyle': ''
        }
      }
    }
  },
  methods: {},
  mounted() {

  }
}
</script>
